<div class="dashboard-wrapper">

  <div class="main-layout">

    <!-- ================= HEADER ================= -->
    <header class="header">
      <div class="header__inner">
        <a routerLink="/beneficiary-layout/checklist" class="header__logo-link">
          <img
            src="https://customer-assets.emergentagent.com/job_trust-design-1/artifacts/zjh02rg0_logo.png"
            alt="Continuum"
            class="header__logo-img"
          />
        </a>
        <div class="header__actions">
          <button class="nav-btn" (click)="logout()">
            <svg class="nav-btn__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
            </svg>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </header>

    <!-- ================= BODY ================= -->
    <div class="layout-body">

      <!-- ================= TOP USER HEADER ================= -->
      <div class="welcome-user-top">
        <div class="welcome-left">
          <div class="name-avatar">
            {{ (selectedContact?.name || userName || 'U').charAt(0).toUpperCase() }}
          </div>
          <h1 class="welcome-section__title">Hello, {{ getFirstName() }}</h1>
        </div>

        <div class="welcome-right">
          <div class="viewing-badge">
            <span class="viewing-badge__label">Legacy Holder:</span>
            <span class="viewing-badge__name">{{ user?.ownerName || 'User' }}</span>
          </div>

          <!-- Only shown when beneficiary has access to multiple owner accounts -->
          <button *ngIf="hasMultipleAccounts" class="switch-btn" (click)="openSwitchDialog()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"/>
            </svg>
            <span>Switch Account</span>
          </button>
        </div>
      </div>

      <!-- ================= MAIN SECTION ================= -->
      <div class="layout-main">

        <aside class="sidebar">
          <nav class="sidebar__nav">

            <a routerLink="/beneficiary-layout/checklist"
               routerLinkActive="sidebar__item--active"
               class="sidebar__item">
              <svg class="sidebar__icon" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2"/>
                <path d="M9 12l2 2 4-4"/>
              </svg>
              <span>Checklist</span>
            </a>

            <a routerLink="/beneficiary-layout/critical-contacts"
               routerLinkActive="sidebar__item--active"
               class="sidebar__item">
              <svg class="sidebar__icon" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07
                         19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67
                         A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.89.37 1.76.72 2.59
                         a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.49-1.29
                         a2 2 0 0 1 2.11-.45c.83.35 1.7.6 2.59.72A2 2 0 0 1 22 16.92z"/>
              </svg>
              <span>Critical Contacts</span>
            </a>

            <a routerLink="/beneficiary-layout/memories-stories"
               routerLinkActive="sidebar__item--active"
               class="sidebar__item">
              <svg class="sidebar__icon" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06
                         a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23
                         l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
              <span>Memories & Stories</span>
            </a>

            <a routerLink="/beneficiary-layout/contact-admin"
               routerLinkActive="sidebar__item--active"
               class="sidebar__item">
              <svg class="sidebar__icon" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                   stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 11a9 9 0 1 1 18 0"/>
                <rect x="2" y="11" width="3" height="5" rx="1"/>
                <rect x="19" y="11" width="3" height="5" rx="1"/>
                <path d="M22 16v1a3 3 0 0 1-3 3h-4"/>
                <circle cx="15" cy="20" r="1"/>
              </svg>
              <span>Contact Admin</span>
            </a>

            <a routerLink="/beneficiary-layout/report-passing"
   routerLinkActive="sidebar__item--active"
   class="sidebar__item">

  <svg class="sidebar__icon"
       xmlns="http://www.w3.org/2000/svg"
       viewBox="0 0 24 24"
       fill="none"
       stroke="currentColor"
       stroke-width="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="12" y1="18" x2="12" y2="12"/>
    <line x1="9" y1="15" x2="15" y2="15"/>
  </svg>

  <span>Report a Passing</span>
</a>
          </nav>
        </aside>

        <main class="content">
          <router-outlet></router-outlet>
        </main>

      </div>
    </div>
  </div>

  <!-- ================================================
       SWITCH ACCOUNT DIALOG
  ================================================= -->
  <div class="dialog-overlay" *ngIf="showSwitchDialog" (click)="closeSwitchDialog()">
    <div class="dialog-box" (click)="$event.stopPropagation()">

      <!-- ── STEP 1: LOGOUT CONFIRM ── -->
      <ng-container *ngIf="switchStep === 'logout-confirm'">
        <div class="dialog-icon dialog-icon--warning">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6
                     a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
          </svg>
        </div>
        <h2 class="dialog-title">Switch Account?</h2>
        <p class="dialog-subtitle">
          You will be logged out from the current owner account.
          Do you want to continue?
        </p>
        <div class="dialog-actions">
          <button class="dialog-btn dialog-btn--cancel" (click)="closeSwitchDialog()">
            Cancel
          </button>
          <button class="dialog-btn dialog-btn--confirm" (click)="confirmLogout()" [disabled]="otpLoading">
            <span *ngIf="!otpLoading">OK</span>
            <span *ngIf="otpLoading" class="btn-spinner"></span>
          </button>
        </div>
      </ng-container>

      <!-- ── STEP 2: SEND OTP CONFIRM ── -->
      <ng-container *ngIf="switchStep === 'send-otp-confirm'">
        <div class="dialog-icon dialog-icon--otp">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8
                 M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5
                 a2 2 0 00-2 2v10a2 2 0 002 2z"/>
          </svg>
        </div>
        <h2 class="dialog-title">Verify to Switch</h2>
        <p>{{ beneficiaryEmail }}</p>

        <div class="dialog-error" *ngIf="otpError">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v2m0 4h.01M12 5a7 7 0 100 14A7 7 0 0012 5z"/>
          </svg>
          {{ otpError }}
        </div>

        <div class="dialog-actions">
          <button class="dialog-btn dialog-btn--cancel" (click)="closeSwitchDialog()">
            Cancel
          </button>
          <button class="dialog-btn dialog-btn--confirm" (click)="sendOtp()" [disabled]="otpLoading">
            <span *ngIf="!otpLoading">Send OTP</span>
            <span *ngIf="otpLoading" class="btn-spinner"></span>
          </button>
        </div>
      </ng-container>

      <!-- ── STEP 3: OTP ENTRY ── -->
      <ng-container *ngIf="switchStep === 'otp'">
        <button class="dialog-back" (click)="switchStep = 'send-otp-confirm'">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
          </svg>
          Back
        </button>

        <div class="dialog-icon dialog-icon--lock">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6
                 a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
          </svg>
        </div>
        <h2 class="dialog-title">Enter OTP</h2>
        <p class="dialog-subtitle">
          We sent a 6-digit code to<br/>
          <strong>{{ beneficiaryEmail }}</strong>
        </p>

        <div class="otp-row">
          <input *ngFor="let i of [0,1,2,3,4,5]"
            type="text"
            inputmode="numeric"
            maxlength="1"
            [id]="'sw-otp-' + i"
            [(ngModel)]="otpDigits[i]"
            [name]="'sw_otp' + i"
            (input)="onOtpInput($event, i)"
            (keydown)="onOtpKeydown($event, i)"
            (paste)="onOtpPaste($event)"
            class="otp-box"
          />
        </div>

        <div class="otp-resend">
          <span *ngIf="resendCooldown > 0" class="otp-resend__countdown">
            Resend in <strong>{{ resendCooldown }}s</strong>
          </span>
          <button *ngIf="resendCooldown === 0" class="otp-resend__btn" (click)="sendOtp()">
            Resend OTP
          </button>
        </div>

        <div class="dialog-error" *ngIf="otpError">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v2m0 4h.01M12 5a7 7 0 100 14A7 7 0 0012 5z"/>
          </svg>
          {{ otpError }}
        </div>

        <button
          class="dialog-btn dialog-btn--confirm dialog-btn--full"
          (click)="verifyOtp()"
          [disabled]="otpLoading || otpDigits.join('').length < 6">
          <span *ngIf="!otpLoading">Verify & Continue</span>
          <span *ngIf="otpLoading" class="btn-spinner"></span>
        </button>
      </ng-container>

      <!-- ── STEP 4: SELECT ACCOUNT ── -->
      <ng-container *ngIf="switchStep === 'accounts'">
        <h2 class="dialog-title" style="margin-bottom: 6px;">Select Account</h2>
        <p class="dialog-subtitle" style="margin-bottom: 16px;">
          Choose an owner account to switch to
        </p>

        <div class="account-list" *ngIf="!accountsLoading">
          <div
            *ngFor="let account of accounts"
            class="account-card"
            [class.account-card--active]="selectedAccount?.id === account.id"
            (click)="selectAccount(account)">
            <div class="account-card__avatar">
              {{ account.ownerName.charAt(0).toUpperCase() }}
            </div>
            <span class="account-card__name">{{ account.ownerName }}</span>
            <svg class="account-card__arrow" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
            </svg>
          </div>
        </div>

        <!-- Loading skeleton -->
        <div class="account-list" *ngIf="accountsLoading">
          <div class="account-card account-card--skeleton" *ngFor="let i of [1,2,3]">
            <div class="skeleton-avatar"></div>
            <div class="skeleton-line"></div>
          </div>
        </div>

        <div class="dialog-error" *ngIf="otpError">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v2m0 4h.01M12 5a7 7 0 100 14A7 7 0 0012 5z"/>
          </svg>
          {{ otpError }}
        </div>

        <button class="dialog-btn dialog-btn--cancel dialog-btn--full"
                style="margin-top: 8px;" (click)="closeSwitchDialog()">
          Cancel
        </button>
      </ng-container>

    </div>
  </div>

</div>